/**
 * Extensions pour l'objet Date
 */

/**
 * Convertit une date de n'importe quel format en objet Date
 * @param {Date|string|Object} date - Date à convertir
 * @returns {Date|null} Date convertie ou null si invalide
 */
export const toDate = (date) => {
  if (!date) return null;
  
  // Si c'est déjà une Date
  if (date instanceof Date) {
    return isNaN(date.getTime()) ? null : date;
  }
  
  // Si c'est un timestamp Firestore avec méthode toDate()
  if (date?.toDate && typeof date.toDate === 'function') {
    return date.toDate();
  }
  
  // Si c'est un plain object avec _seconds (Firestore timestamp sérialisé)
  if (date?._seconds !== undefined) {
    const milliseconds = date._seconds * 1000 + (date._nanoseconds || 0) / 1000000;
    const parsed = new Date(milliseconds);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  
  // Si c'est une chaîne de caractères
  if (typeof date === 'string') {
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  
  return null;
};

/**
 * Vérifie si une date est valide
 * @param {Date|string|Object} date - Date à vérifier
 * @returns {boolean}
 */
export const isValidDate = (date) => {
  const converted = toDate(date);
  return converted !== null;
};

/**
 * Convertit une Date (ou ISO string) en string datetime-local pour les <input type="datetime-local">.
 * La conversion respecte le timezone local du browser (contrairement à toISOString() qui est UTC).
 *
 * @param {Date|string} date - Date à convertir
 * @returns {string} Format "YYYY-MM-DDTHH:mm" en heure locale, ou '' si invalide
 */
export const toLocalDateTimeString = (date) => {
  const d = toDate(date);
  if (!d) return '';
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60000);
  return local.toISOString().slice(0, 16);
}; 